// ─── FONTS ─────────────────────────────────────────────────────────────────────
export const FONTS = ["Quicksand","Nunito","Poppins","Lato","Raleway","Pacifico","Comfortaa","Caveat"];
